import React, { FC } from 'react';
import FinalFormInputWrapper from './FinalFormInputWrapper';
import { TextArea } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

const TextAreaWrapper: FC<FieldRenderProps<string>> = (props) => (
  <FinalFormInputWrapper {...props} component={TextArea} />
);

export default TextAreaWrapper;
